/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_Action_StartInputs */

const en_us2_search_preview_action_start = /** @type {(inputs: Search_Preview_Action_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before you start, two quick questions about sleep and stress adjust today's workout.`)
};

const pt_br2_search_preview_action_start = /** @type {(inputs: Search_Preview_Action_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes de começar, duas perguntas rápidas sobre sono e estresse ajustam o treino de hoje.`)
};

const es_419_search_preview_action_start = /** @type {(inputs: Search_Preview_Action_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes de empezar, dos preguntas rápidas sobre sueño y estrés ajustan el entrenamiento de hoy.`)
};

const pt_pt2_search_preview_action_start = /** @type {(inputs: Search_Preview_Action_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes de começares, duas perguntas rápidas sobre sono e stress ajustam o treino de hoje.`)
};

const fr_fr2_search_preview_action_start = /** @type {(inputs: Search_Preview_Action_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avant de commencer, deux questions rapides sur le sommeil et le stress ajustent la séance du jour.`)
};

const de_de2_search_preview_action_start = /** @type {(inputs: Search_Preview_Action_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor dem Start passen zwei kurze Fragen zu Schlaf und Stress das heutige Training an.`)
};

const it_it2_search_preview_action_start = /** @type {(inputs: Search_Preview_Action_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima di iniziare, due domande veloci su sonno e stress adattano l'allenamento di oggi.`)
};

/**
* | output |
* | --- |
* | "Before you start, two quick questions about sleep and stress adjust today's workout." |
*
* @param {Search_Preview_Action_StartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_action_start = /** @type {((inputs?: Search_Preview_Action_StartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_Action_StartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_action_start(inputs)
	if (locale === "es-419") return es_419_search_preview_action_start(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_action_start(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_action_start(inputs)
	if (locale === "de-DE") return de_de2_search_preview_action_start(inputs)
	if (locale === "it-IT") return it_it2_search_preview_action_start(inputs)
	return en_us2_search_preview_action_start(inputs)
});
export { search_preview_action_start as "search.preview_action_start" }